import React from 'react';
import { Button, Collapse } from 'reactstrap';

import config from '../../../../config';
import { Toggler } from '../../../../components';

export function Accordian(props) {
  return (
    <Toggler initialOn={props.isOpen}>
      {({ toggle, on }) => {
        return (
          <div className="flight-acc">
            <Button color="primary" onClick={toggle}>
              <h3>{props.title}</h3>{' '}
              <i className="icon icon-hg-chev-down" />
            </Button>
            <Collapse isOpen={on}>{props.children}</Collapse>
          </div>
        );
      }}
    </Toggler>
  );
}

Accordian.defaultProps = {
  isOpen: false,
};

export const Group = props => <div {...props} className="wrapper" />;

export const Question = props => <h5>{props.question}</h5>;

export const Answer = props => <p {...props} />;

export function Email() {
  return (
    <a href={`mailto:${config.honeyguideEmail}`}> {config.honeyguideEmail}</a>
  );
}
export function SupportEmail() {
  return (
    <a href={`mailto:${config.honeyguideSupportEmail}`}> {config.honeyguideSupportEmail}</a>
  );
}

export function Call() {
  return (
    <React.Fragment>
      call / whatsapp us at
      <a
        target="_blank"
        href={`https://api.whatsapp.com/send?phone=${config.honeyguidePhoneNumber}`}
        rel="noopener noreferrer"
      >
        {' '}
        <b>{config.honeyguidePhoneNumber}</b>
      </a>
    </React.Fragment>
  );
}

export function SupportCall() {
  return (
    <React.Fragment>
      call / whatsapp us at
      <a
        target="_blank"
        href={`https://api.whatsapp.com/send?phone=${config.honeyguideSupportPhoneNumber}`}
        rel="noopener noreferrer"
      >
        {' '}
        <b>{config.honeyguideSupportPhoneNumber}</b>
      </a>
    </React.Fragment>
  );
}

export function CallSummit() {
  return (
    <React.Fragment>
      {config.summitPhoneNumbers.map(ph => (
        <a href={`tel:+${ph}`} key={ph}>
          {' '}
          <b>+{ph}</b>,{' '}
        </a>
      ))}
    </React.Fragment>
  );
}

export const EmailSummit = () => (
  <a href={`mailto:${config.summitEmail}`}> {config.summitEmail}</a>
);



// WEBPACK FOOTER //
// ./src/screens/Flights/SearchAndResults/StaticSections/common.js